import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "icon-sizes"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#icon-sizes" }),
  /*#__PURE__*/_createTextVNode(" Icon Sizes ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The font icons can be sized using "),
  /*#__PURE__*/_createVNode("code", null, ".fs-{size}"),
  /*#__PURE__*/_createTextVNode(" class that defined with "),
  /*#__PURE__*/_createVNode("code", null, "$font-sizes"),
  /*#__PURE__*/_createTextVNode(" variable in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Where ")
const _hoisted_6 = /*#__PURE__*/_createVNode("code", null, "size", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" is one of: ")
const _hoisted_8 = { class: "pt-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" - sets icon size that equals to ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" font size ")
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<li class=\"py-2\"><code>7</code> - sets icon size that equals to <code>0.95 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>8</code> - sets icon size that equals to <code>0.85 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>9</code> - sets icon size that equals to <code>0.75 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>10</code> - sets icon size that equals to <code>0.5 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>base</code> - sets icon size that equals to <code>$font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>fluid</code> - sets icon size that equals to <code>100%</code></li>", 6)
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" - sets icon size that equals to ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" where ")
const _hoisted_20 = /*#__PURE__*/_createVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_21 = { class: "py-2" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" - sets icon size that equals to ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" where ")
const _hoisted_24 = /*#__PURE__*/_createVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_25 = { class: "py-2" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" - sets icon size that equals to ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" where ")
const _hoisted_28 = /*#__PURE__*/_createVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_29 = { class: "py-2" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" - sets icon size that equals to ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" where ")
const _hoisted_32 = /*#__PURE__*/_createVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_33 = { class: "py-5" }
const _hoisted_34 = { class: "rounded border d-flex flex-wrap p-10" }
const _hoisted_35 = { class: "d-flex flex-center flex-grow-1" }
const _hoisted_36 = { class: "fw-bold py-2 text-center" }
const _hoisted_37 = { class: "py-5" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<i class="far fa-lightbulb fs-5x"></i>
        <i class="far fa-lightbulb fs-4x"></i>
        <i class="far fa-lightbulb fs-3x"></i>
        <i class="far fa-lightbulb fs-2tx"></i>
        <i class="far fa-lightbulb fs-2hx"></i>
        <i class="far fa-lightbulb fs-2qx"></i>
        <i class="far fa-lightbulb fs-2x"></i>
        <i class="far fa-lightbulb fs-1"></i>
        <i class="far fa-lightbulb fs-2"></i>
        <i class="far fa-lightbulb fs-3"></i>
        <i class="far fa-lightbulb fs-5"></i>
        <i class="far fa-lightbulb fs-6"></i>`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode("ul", _hoisted_8, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (i) => {
          return _createVNode("li", {
            key: i,
            class: "py-2"
          }, [
            _createVNode("code", null, _toDisplayString(i), 1),
            _hoisted_9,
            _createVNode("code", null, "<h" + _toDisplayString(i++) + ">", 1),
            _hoisted_10
          ])
        }), 64)),
        _hoisted_11,
        (_openBlock(), _createBlock(_Fragment, null, _renderList([2, 3, 4, 5], (i) => {
          return (_openBlock(), _createBlock(_Fragment, { key: i }, [
            _createVNode("li", _hoisted_17, [
              _createVNode("code", null, _toDisplayString(i) + "x", 1),
              _hoisted_18,
              _createVNode("code", null, _toDisplayString(i) + " of $font-size-base", 1),
              _hoisted_19,
              _hoisted_20
            ]),
            _createVNode("li", _hoisted_21, [
              _createVNode("code", null, _toDisplayString(i) + "qx", 1),
              _hoisted_22,
              _createVNode("code", null, _toDisplayString(i) + ".25 of $font-size-base", 1),
              _hoisted_23,
              _hoisted_24
            ]),
            _createVNode("li", _hoisted_25, [
              _createVNode("code", null, _toDisplayString(i) + "hx", 1),
              _hoisted_26,
              _createVNode("code", null, _toDisplayString(i) + ".5 of $font-size-base", 1),
              _hoisted_27,
              _hoisted_28
            ]),
            _createVNode("li", _hoisted_29, [
              _createVNode("code", null, _toDisplayString(i) + "tx", 1),
              _hoisted_30,
              _createVNode("code", null, _toDisplayString(i) + ".75 of $font-size-base", 1),
              _hoisted_31,
              _hoisted_32
            ])
          ], 64))
        }), 64))
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      _createVNode("div", _hoisted_34, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sizes, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "d-flex flex-column h-100px w-100px me-10 mb-5"
          }, [
            _createVNode("div", _hoisted_35, [
              _createVNode("i", {
                class: [`fs-${item}`, "far fa-lightbulb"]
              }, null, 2)
            ]),
            _createVNode("div", _hoisted_36, ".fs-" + _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_38
        ]),
        _: 1
      })
    ])
  ]))
}